// @ts-nocheck
import { extendTheme } from "@chakra-ui/react";
import foundations from "./foundations";
import { theme as ProTheme } from "./pro-theme";
import styles from "./styles";

const overrides = {
  styles,
  // Other foundational style overrides go here
  ...foundations,
  fonts: {
    ...foundations.fonts,
    cursive: "var(--font-shantell-sans)",
  },
};

export default extendTheme(overrides, ProTheme);
